import api from "./../config";

// List users
export const GetUsersAPI = async (data) => {
  const response = await api({
    method: "POST",
    url: "api/v1/users/list",
    data: data,
  });
  return response;
};

// Get single user info

export const GetUserInfoAPI = async (userId) => {
  const response = await api({
    method: "GET",
    url: `api/v1/users/:${userId}`,
  });
  return response;
};

// Create a new user
export const CreateUserAPI = async (data) => {
  const response = await api({
    method: "POST",
    url: "api/v1/users/create-user",
    data: data,
  });
  return response;
};

// Update user (general details)
export const UpdateUserAPI = async ({ userId, data }) => {
  const response = await api({
    method: "PUT",
    url: `api/v1/users/${userId}`,
    data: data,
  });
  return response;
};

export const updateProfileAPI = async (data) => {
  return api({
    method: "PUT",
    url: "api/v1/users/self/profile",
    data,
  });
};

export const updatePasswordAPI = async (data) => {
  const response = await api({
    method: "POST",
    url: "api/v1/users/self/change-password",
    data,
  });
  return response.data;
};

export const UpdateUserStatusAPI = async ({ userId, action }) => {
  const response = await api({
    method: "PATCH",
    url: `api/v1/users/${userId}/changeStatus`,
    data: {
      status: action,
    },
  });
  return response;
};

// Delete user
export const DeleteUserAPI = async (userId) => {
  const response = await api({
    method: "PATCH",
    url: `api/v1/users/${userId}/softDelete`,
  });
  return response;
};
